import React from "react"
import PropTypes from "prop-types"
import { SelectTree } from "@tencent/spaui-business"
import _ from "lodash"
import { withApi } from "@tencent/react-aio"
import { connect } from "react-redux"
import * as ActionTypes from "@/stores/sale/actions"

class TeamUserSelect extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    organizationTree: PropTypes.object,
    employeeRepo: PropTypes.object,
    employeeList: PropTypes.arrayOf(
      PropTypes.shape({
        employeeId: PropTypes.number.isRequired,
        operationUserName: PropTypes.string,
      })
    ),
    // value: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {}
    this.getEmployee = _.debounce(this.getEmployee, 1500)
  }

  componentDidMount() {
    const { webApi, organizationTree, employeeList } = this.props
    if (_.isEmpty(organizationTree)) {
      webApi.getOrganizationTreeIfNeed().dispatch(ActionTypes.FETCH_ORGANIZATION_TREE)
    }
    if (!employeeList) {
      webApi.queryPureFullEmployeeUserList()
    }
  }

  render() {
    const { organizationTree, onChange, value, disabled, readOnly, employeeRepo, multiple = false } = this.props

    function getEmployeeNode(employee) {
      let user = employeeRepo[employee.userId] || {}
      if (user.status !== "EMPLOYEE_SYSTEM_STATUS_NORMAL") {
        return null
      }
      return {
        value: employee.userId,
        desc: user.operationUserName || employee.name || employee.qqNumber || employee.userId,
      }
    }

    function getTeamNode(team) {
      return {
        value: team.name,
        desc: team.name,
        not_allow_selected: true,
        options: _.concat(
          _.map(team.children, (t) => getTeamNode(t)),
          _.compact(_.map(team.employees, (e) => getEmployeeNode(e)))
        ),
      }
    }

    const data =
      organizationTree &&
      _.concat(
        _.map(organizationTree.teams, (t) => getTeamNode(t)),
        _.compact(_.map(organizationTree.freeEmployees, (e) => getEmployeeNode(e)))
      )
    const { searchValue, searchValueData, loading } = this.state

    return (
      <SelectTree
        className="employee-select-tree"
        SelectProps={{ loading }}
        multiple={multiple}
        clearable={!disabled}
        unrelated={true}
        showParentNodeLabel={false}
        data={data || []}
        value={value}
        onChange={onChange}
        disabled={disabled || readOnly}
        search={true}
        searchValue={searchValue}
        searchValueData={searchValueData}
        onSearch={this.handleSearch}
      />
    )
  }

  handleSearch = (e, searchValue) => {
    searchValue = searchValue.trim()
    this.setState({ searchValue, loading: true })
    this.getEmployee(searchValue)
  }

  getEmployee = (keywords) => {
    const { webApi } = this.props
    webApi
      .getEmployeeUserList()
      .ajax({
        data: { keywords, field: "USER_NAME" },
      })
      .then((res) => {
        if (res) {
          if (!keywords) {
            this.setState({ searchValueData: undefined, loading: false })
            return
          }
          const { list = [] } = res
          const searchValueData = list
            .filter((v) => v.status !== "EMPLOYEE_SYSTEM_STATUS_SUSPEND")
            .map((employee) => {
              return {
                value: employee.employeeId,
                label: employee.operationUserName,
              }
            })
          this.setState({
            searchValueData,
            loading: false,
          })
        }
      })
      .catch((e) => {
        this.setState({
          searchValueData: undefined,
          loading: false,
        })
      })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    organizationTree: state.organizationTree.tree,
    employeeRepo: state.fullEmployeeRepo,
    employeeList: state.fullEmployeeList.list && _.map(state.fullEmployeeList.list, (employeeId) => state.fullEmployeeRepo[employeeId]),
  }
}

export default withApi(connect(mapStateToProps)(TeamUserSelect))
